<template>
    <div>
        <div class="container-fluid">
            <CRow class="pr-2">
                <CCol col="12" xl="12" class="p-0">
                    <CCard>
                        <CCardBody>
                            <a-card class="edit-card" style="margin:0;" :body-style="{padding:0}">
                                <span slot="title">
                                    <h6 class="w-100 mb-0 text-muted">Rezervácie</h6>
                                    Zoznam rezervácií
                                </span>
                                <span slot="extra">
                                    <span class="text-muted" v-if="!loading">Výsledkov: <span class="text-bold">{{data.length}}</span></span>
                                </span>

                                <div class="px-4 pb-3 pt-3">
                                    <a-row :gutter="16">
                                        <a-col :span="8">
                                            <a-select v-model="filters.cabin" placeholder="Všetky chaty" style="width: 100%" @change="fetch" allowClear>
                                                <a-select-option v-for="cabin in cabins" :key="cabin.id" :value="cabin.id">
                                                    {{ cabin.title }}
                                                </a-select-option>
                                            </a-select>
                                        </a-col>
                                        <a-col :span="8">
                                            <a-select v-model="filters.status" placeholder="Všetky stavy" style="width: 100%" @change="fetch" allowClear>
                                                <a-select-option value="pending">Čaká na potvrdenie</a-select-option>
                                                <a-select-option value="payment_recieved">Platba prijatá</a-select-option>
                                                <a-select-option value="completed">Dokončená</a-select-option>
                                                <a-select-option value="storno">Stornovaná</a-select-option>
                                                <a-select-option value="abandoned">Opustená</a-select-option>
                                            </a-select>
                                        </a-col>
                                        <a-col :span="8">
                                            <a-range-picker v-model="filters.dateRange" format="DD.MM.YYYY" style="width: 100%" @change="fetch" />
                                        </a-col>
                                    </a-row>
                                </div>

                                <div class="table-responsive">
                                    <a-table
                                        :columns="columns"
                                        :rowKey="record => record.id"
                                        :dataSource="data"
                                        :loading="loading"
                                        class="table-flush">

                                        <template slot="order_number" slot-scope="text, record">
                                            <strong>{{ text }}</strong>
                                            <br><small>{{ record.created_at }}</small>
                                        </template>

                                        <template slot="cabin" slot-scope="text, record">
                                            {{ text }}
                                            <br><small v-if="record.apartment_id">Apartmán {{ record.apartment_id }}</small>
                                        </template>

                                        <template slot="guest" slot-scope="text, record">
                                            {{ record.guest_name }}
                                            <br><small>{{ record.guest_email }}</small>
                                        </template>

                                        <template slot="dates" slot-scope="text, record">
                                            {{ formatDate(record.check_in) }} - {{ formatDate(record.check_out) }}
                                            <br><small>{{ record.nights }} {{ record.nights === 1 ? 'noc' : record.nights < 5 ? 'noci' : 'nocí' }}</small>
                                        </template>

                                        <template slot="guests_count" slot-scope="text, record">
                                            {{ record.adults }} dosp.
                                            <span v-if="record.children > 0"> + {{ record.children }} deti</span>
                                        </template>

                                        <template slot="total_price" slot-scope="text">
                                            <strong>{{ text }} €</strong>
                                        </template>

                                        <template slot="order_status" slot-scope="text">
                                            <a-tag :color="getStatusColor(text)">
                                                {{ getStatusLabel(text) }}
                                            </a-tag>
                                        </template>

                                        <template slot="payment_method" slot-scope="text">
                                            {{ getPaymentLabel(text) }}
                                        </template>

                                        <template slot="actions" slot-scope="record">
                                            <div class="d-flex align-items-center justify-content-end" style="gap:6px;">
                                                <a-button size="small" @click="viewBooking(record.id)">Zobraziť detail</a-button>
                                                <a-button size="small" v-if="record.order_status === 'pending'" @click="changeStatus(record.id, 'payment_recieved')">Potvrdiť platbu</a-button>
                                                <a-button size="small" v-if="record.order_status === 'payment_recieved'" @click="changeStatus(record.id, 'completed')">Dokončené</a-button>
                                                <a-popconfirm
                                                    v-if="record.order_status !== 'storno'"
                                                    title="Naozaj chcete stornovať túto rezerváciu?"
                                                    @confirm="changeStatus(record.id, 'storno')"
                                                    okText="Áno"
                                                    cancelText="Nie">
                                                    <a-button size="small" type="danger" ghost>Stornovať</a-button>
                                                </a-popconfirm>
                                            </div>
                                        </template>
                                    </a-table>
                                </div>
                            </a-card>
                        </CCardBody>
                    </CCard>
                </CCol>
            </CRow>
        </div>
    </div>
</template>

<script>
import {dataService} from "../_services";
import {Popconfirm} from "ant-design-vue";

const columns = [
    {
        title: 'Číslo objednávky',
        dataIndex: 'id',
        scopedSlots: {customRender: 'order_number'},
    },
    {
        title: 'Chata',
        dataIndex: 'cabin_name',
        scopedSlots: {customRender: 'cabin'},
    },
    {
        title: 'Hosť',
        scopedSlots: {customRender: 'guest'},
    },
    {
        title: 'Termín',
        scopedSlots: {customRender: 'dates'},
    },
    {
        title: 'Osoby',
        scopedSlots: {customRender: 'guests_count'},
    },
    {
        title: 'Cena',
        dataIndex: 'total_price',
        scopedSlots: {customRender: 'total_price'},
    },
    {
        title: 'Stav',
        dataIndex: 'order_status',
        scopedSlots: {customRender: 'order_status'},
    },
    {
        title: 'Platba',
        dataIndex: 'payment_method',
        scopedSlots: {customRender: 'payment_method'},
    },
    {
        align: 'right',
        scopedSlots: {customRender: 'actions'},
    }
];

export default {
    name: "cabin-bookings",
    components: {
        "a-popconfirm": Popconfirm
    },
    data() {
        return {
            data: [],
            cabins: [],
            loading: false,
            columns,
            filters: {
                cabin: null,
                status: null,
                dateRange: []
            }
        };
    },
    mounted() {
        this.fetchCabins();
        this.fetch();
    },
    methods: {
        formatDate(d) {
            if (!d) return '-';
            const parts = d.split('-');
            if (parts.length === 3) return parts[2] + '.' + parts[1] + '.' + parts[0];
            return d;
        },
        fetchCabins() {
            dataService.axiosFetch('content/cabins').then(results => {
                if (results && typeof results === 'object' && !Array.isArray(results)) {
                    this.cabins = Object.values(results).filter(item => item && item.id && typeof item === 'object');
                } else {
                    this.cabins = Array.isArray(results) ? results : [];
                }
            });
        },
        fetch() {
            this.loading = true;
            const params = {
                cabin_id: this.filters.cabin,
                status: this.filters.status,
                date_from: this.filters.dateRange[0] ? this.filters.dateRange[0].format('YYYY-MM-DD') : null,
                date_to: this.filters.dateRange[1] ? this.filters.dateRange[1].format('YYYY-MM-DD') : null
            };

            dataService.axiosPost('cabin-bookings/filter', params).then(results => {
                let data = [];
                const payload = results && results.data && results.data.data ? results.data.data : {};
                if (payload.reservations) {
                    data = payload.reservations;
                } else if (Array.isArray(payload)) {
                    data = payload;
                }
                this.data = Array.isArray(data) ? data : [];
                this.loading = false;
            });
        },
        viewBooking(id) {
            this.$router.push(`/cabin-booking/${id}`);
        },
        changeStatus(id, status) {
            dataService.axiosPost(`cabin-bookings/${id}/status`, {status}).then(() => {
                this.fetch();
            });
        },
        getStatusColor(status) {
            const colors = {
                pending: 'orange',
                payment_recieved: 'blue',
                completed: 'green',
                storno: 'red',
                abandoned: 'gray'
            };
            return colors[status] || 'default';
        },
        getStatusLabel(status) {
            const labels = {
                pending: 'Čaká na potvrdenie',
                payment_recieved: 'Platba prijatá',
                completed: 'Dokončená',
                storno: 'Stornovaná',
                abandoned: 'Opustená'
            };
            return labels[status] || status;
        },
        getPaymentLabel(method) {
            const labels = {
                bank: 'Bankový prevod',
                webpay: 'GP webpay',
                cardpay: 'Platba kartou',
                desk: 'Platba na mieste'
            };
            return labels[method] || method;
        }
    },
};
</script>

<style scoped>
.ant-table {
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    margin-bottom: 20px;
}
</style>
